import {
  SUBMIT_FORM_SUCCESS,
  FETCH_QUESTIONS_SUCCESS,
  SUBMIT_FORM_ERROR,
  SUBMIT_FORM_LOADING,
  FETCH_QUESTIONS_ERROR,
  FETCH_CLINICS_SUCCESS,
  FETCH_CLINICS_FAILURE
} from '../actions/bmiQuizActions';


const initialState = {
    questions: [],  
    error: null,
    isSubmitted: false,
    successMessage: null, 
    clinics: []
  };

  
  const bmiQuizReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_QUESTIONS_SUCCESS':
        return {
          ...state,
          questions: action.payload,
        };
      case 'FETCH_QUESTIONS_ERROR':
        return {
          ...state,
          error: action.payload,
        };
        case SUBMIT_FORM_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
        isSubmitted: false,
      };

      case SUBMIT_FORM_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isSubmitted: true,
          successMessage: `Thank you for your interest in the Perspectives in Care RPM wellness program. 
          A Perspectives in Care team member will be in touch shortly to discuss the program further. 
          Have a great day!`,
        };

    case SUBMIT_FORM_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isSubmitted: false,
      };

    case 'FETCH_CLINICS_SUCCESS':
      return { ...state, 
        clinics: action.payload }; 
    case 'FETCH_CLINICS_FAILURE':
      return { ...state, 
        error: action.payload };
      default:
        return state;
    }
  };
  

export default bmiQuizReducer;
